










import Vue from "vue";
import billboardImage from "@/assets/images/artworks/billboard-preview.png";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

// BE-only feature: there's no English billboard artwork, so English funnels
// fall back to the FR/NL artwork.
const BILLBOARD_IMAGE_BY_LOCALE: Record<string, string> = {
    nl: billboardImage,
    fr: billboardImage,
    en: billboardImage,
};

export default Vue.extend({
    computed: {
        billboardImage: function(): string {
            return BILLBOARD_IMAGE_BY_LOCALE[Trans.currentLocale] || billboardImage;
        },
    },
});
